import { Link } from 'react-router-dom'
import { useRef, useState, useEffect } from 'react'
import videoSrc from '../assets/UniFi Networking Innovations_ Site Manager _ Network 8.3 _ Cloud Gateway Max.mp4'
import t3 from '../assets/t3.jpg'
import t4 from '../assets/t4.jpg'
import './Technology.css'

function TechnologyPage({ lang }) {
  const isFr = lang === 'fr'
  const videoRef = useRef(null)
  const [playing, setPlaying] = useState(true)

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1)
      const el = document.getElementById(id)
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)
    }
  }, [])

  const togglePlay = () => {
    if (!videoRef.current) return
    if (playing) { videoRef.current.pause(); setPlaying(false) }
    else { videoRef.current.play(); setPlaying(true) }
  }

  const pillars = isFr ? [
    { icon: '🤖', title: 'IA pratique, supervision humaine', body: 'Nous intégrons une IA responsable dans l\'apprentissage, le commerce et les opérations — avec contrôle humain et adaptation aux réalités locales.' },
    { icon: '☁️', title: 'Digitalisation des institutions', body: 'Accompagnement des organisations dans l\'adoption d\'outils modernes : processus, cloud, automatisation et formation.' },
    { icon: '🌐', title: 'Déploiement terrain CM → RCA', body: 'Exécution ancrée sur le terrain, du Cameroun à la RCA — pour que le digital rejoigne les utilisateurs réels.' },
  ] : [
    { icon: '🤖', title: 'Practical AI, Human Oversight', body: 'We embed responsible AI into learning, commerce, and operations — with human oversight and fit for local realities.' },
    { icon: '☁️', title: 'Institutional Digitalization', body: 'We help organizations adopt modern tools: processes, cloud, automation, and team enablement.' },
    { icon: '🌐', title: 'On-Ground Delivery CM → CAR', body: 'Execution rooted on the ground, from Cameroon to CAR — so digital products reach real users.' },
  ]

  const solutions = isFr ? [
    { icon: '🌍', title: 'Partenaires technologiques', body: 'Nous coopérons avec des fournisseurs cloud et IT pour accompagner la digitalisation des institutions et des entreprises.' },
    { icon: '🖥️', title: 'Équipements IT et déploiement', body: 'Déploiement d\'équipements IT : serveurs, réseau, matériel et infrastructure de support.' },
    { icon: '📡', title: 'Connectivité et écosystèmes', body: 'Facilitation de la connectivité et des systèmes de communication numériques — urbains et ruraux.' },
  ] : [
    { icon: '🌍', title: 'Technology Partners', body: 'We work with cloud and IT providers to help institutions and businesses digitize operations.' },
    { icon: '🖥️', title: 'IT Equipment and Deployment', body: 'We deploy IT equipment: servers, networking, computing hardware, and supporting infrastructure.' },
    { icon: '📡', title: 'Connectivity and Ecosystems', body: 'We facilitate connectivity and digital communication systems — urban and remote.' },
  ]

  const platforms = isFr ? [
    { icon: '📚', name: 'OnboardLearning.org', blurb: 'LMS bilingue FR/EN — plateformes d\'apprentissage assistées par l\'IA pour l\'éducation.', href: 'https://onboardlearning.org', cta: 'Visiter OnboardLearning' },
    { icon: '🛒', name: 'Galababa.com', blurb: 'Marketplace de Bangui — commerce digital local pour connecter vendeurs et acheteurs.', href: 'https://galababa.com', cta: 'Visiter Galababa' },
    { icon: '💬', name: 'KesseDesk', blurb: 'KesseDesk — chat en direct et noms de domaine pour les entreprises : ajoutez le support client à votre site en quelques minutes.', href: 'https://www.kessedesk.com', cta: 'Visiter KesseDesk' },
  ] : [
    { icon: '📚', name: 'OnboardLearning.org', blurb: 'Bilingual FR/EN LMS — AI-enabled learning platforms for education.', href: 'https://onboardlearning.org', cta: 'Visit OnboardLearning' },
    { icon: '🛒', name: 'Galababa.com', blurb: 'Bangui marketplace — local digital commerce connecting sellers and buyers.', href: 'https://galababa.com', cta: 'Visit Galababa' },
    { icon: '💬', name: 'KesseDesk', blurb: 'KesseDesk — live chat and domains for businesses: add customer support to your website in minutes.', href: 'https://www.kessedesk.com', cta: 'Visit KesseDesk' },
  ]

  return (
    <div className="tech-page">
      <section className="tech-hero">
        <div className="tech-hero-overlay" />
        <img src={t3} alt="" className="tech-hero-bg" />
        <div className="tech-hero-content">
          <span className="tech-hero-eyebrow">{isFr ? 'Technologie et IA' : 'Technology & AI'}</span>
          <h1 className="tech-hero-title">{isFr ? 'Technologie et IA' : 'Technology & AI'}</h1>
          <p className="tech-hero-sub">{isFr ? 'Digitalisation pratique et IA responsable — plateformes pour l\'apprentissage, le commerce et les opérations, conçues pour le terrain, déployées du Cameroun à la RCA.' : 'Practical digitalization and responsible AI — platforms for learning, commerce, and operations, built for local realities, delivered from Cameroon to CAR.'}</p>
          <div className="tech-hero-actions">
            <Link to="/contact" className="tech-btn primary">{isFr ? 'Démarrer un projet' : 'Start a Project'}</Link>
            <a href="#platforms" className="tech-btn outline">{isFr ? 'Nos plateformes' : 'Our Platforms'}</a>
          </div>
        </div>
      </section>

      <section className="tech-pillars">
        <div className="tech-pillars-inner">
          <h2 className="tech-section-title tech-center">{isFr ? 'Notre approche' : 'Our Approach'}</h2>
          <p className="tech-section-sub tech-center">{isFr ? 'Digitalisation pratique, IA sous supervision humaine, déploiement local.' : 'Practical digitalization, AI with human oversight, local delivery.'}</p>
          <div className="tech-pillars-grid">
            {pillars.map((p, i) => (
              <div key={i} className="tech-pillar-card">
                <span className="tech-pillar-icon">{p.icon}</span>
                <h3 className="tech-pillar-title">{p.title}</h3>
                <p className="tech-pillar-body">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="platforms" className="tech-solutions" style={{ scrollMarginTop: 80 }}>
        <div className="tech-solutions-inner">
          <h2 className="tech-section-title tech-center">{isFr ? 'Plateformes digitales' : 'Digital Platforms'}</h2>
          <p className="tech-section-sub tech-center">{isFr ? 'OnboardLearning (LMS FR/EN), Galababa (marketplace Bangui) et KesseDesk (chat en direct et domaines).' : 'OnboardLearning (FR/EN LMS), Galababa (Bangui marketplace) and KesseDesk (live chat and domains).'}</p>
          <div className="tech-solutions-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
            {platforms.map((p) => (
              <div key={p.name} className="tech-solution-card">
                <span className="tech-solution-icon">{p.icon}</span>
                <h3 className="tech-solution-title">{p.name}</h3>
                <p className="tech-solution-body">{p.blurb}</p>
                <a href={p.href} target="_blank" rel="noreferrer" className="tech-btn primary" style={{ marginTop: 20, display: 'inline-block' }}>{p.cta}</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="energy" className="tech-energy" style={{ scrollMarginTop: 80 }}>
        <div className="tech-pillars-inner">
          <h2 className="tech-section-title tech-center">{isFr ? 'Énergie' : 'Energy'}</h2>
          <p className="tech-section-sub tech-center">{isFr ? 'Accès à l\'énergie et partenariats — une piste d\'avenir.' : 'Energy access and partnerships — a forward-looking pillar.'}</p>
          <div className="tech-pillars-grid" style={{ gridTemplateColumns: '1fr', maxWidth: 720, margin: '0 auto' }}>
            <div className="tech-pillar-card">
              <span className="tech-pillar-icon">⚡</span>
              <h3 className="tech-pillar-title">{isFr ? 'Explorer l\'accès à l\'énergie' : 'Exploring Energy Access'}</h3>
              <p className="tech-pillar-body">{isFr ? 'Groupe Ouambo explore des partenariats autour de l\'accès à l\'énergie — pour soutenir la digitalisation, les opérations et les communautés, par des études, des partenaires et un déploiement progressif.' : 'Groupe Ouambo is exploring partnerships around energy access — to support digitalization, operations, and communities through studies, partners, and progressive rollout.'}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="tech-media">
        <div className="tech-media-inner">
          <div className="tech-video-wrap" onClick={togglePlay}>
            <video ref={videoRef} src={videoSrc} className="tech-video" playsInline autoPlay muted loop preload="auto" onEnded={() => setPlaying(false)} />
            {!playing && (<div className="tech-video-play"><span>▶</span></div>)}
            <div className="tech-video-label">{isFr ? 'UniFi — Innovations Réseau' : 'UniFi — Network Innovations'}</div>
          </div>
          <img src={t4} alt="" className="tech-media-img" />
        </div>
      </section>

      <section className="tech-solutions">
        <div className="tech-solutions-inner">
          <h2 className="tech-section-title tech-center">{isFr ? 'Services de digitalisation' : 'Digitalization Services'}</h2>
          <div className="tech-solutions-grid">
            {solutions.map((s, i) => (
              <div key={i} className="tech-solution-card">
                <span className="tech-solution-icon">{s.icon}</span>
                <h3 className="tech-solution-title">{s.title}</h3>
                <p className="tech-solution-body">{s.body}</p>
              </div>
            ))}
          </div>
          <div className="tech-solutions-closing">
            <p>{isFr ? 'La logistique et le corridor restent un pilier opérationnel du groupe — pour que les produits numériques rejoignent les utilisateurs réels sur le terrain.' : 'Logistics and the corridor remain an operational pillar of the group — so digital products reach real users on the ground.'}</p>
          </div>
        </div>
      </section>

      <section className="tech-feature">
        <img src={t3} alt="" className="tech-feature-img tech-feature-img-left" />
        <div className="tech-feature-text">
          <h2>{isFr ? 'Du digital qui fonctionne sur le terrain' : 'Digital That Works on the Ground'}</h2>
          <p>{isFr ? 'De OnboardLearning à Galababa et KesseDesk, en passant par la digitalisation des institutions — notre approche associe produits numériques et présence locale.' : 'From OnboardLearning to Galababa and KesseDesk to institutional digitalization — our approach pairs digital products with local presence.'}</p>
          <Link to="/contact" className="tech-btn primary" style={{ marginTop: 24, display: 'inline-block' }}>{isFr ? 'Parlez à notre équipe' : 'Talk to Our Team'}</Link>
        </div>
        <img src={t4} alt="" className="tech-feature-img tech-feature-img-right" />
      </section>

      <div className="tech-contact-strip">
        <p>{isFr ? 'Contact RCA / général : ' : 'CAR / general contact: '}<a href="mailto:mp@groupeouambo.com">mp@groupeouambo.com</a>{' · '}<a href="mailto:info@groupeouambo.com">info@groupeouambo.com</a></p>
      </div>

      <section className="tech-cta">
        <div className="tech-cta-inner">
          <h2>{isFr ? 'Prêt à digitaliser ?' : 'Ready to Digitize?'}</h2>
          <p>{isFr ? 'Parlons plateformes, IA pratique et déploiement local.' : 'Let\'s talk platforms, practical AI, and local delivery.'}</p>
          <Link to="/contact" className="tech-btn primary">{isFr ? 'Contactez-nous' : 'Get Started'}</Link>
        </div>
      </section>
    </div>
  )
}

export default TechnologyPage
